// CreateTexasRoom.jsx
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import GamesNavbar from "../components/GamesNavbar";
import SceneBackground from "../../components/scene/SceneBackground";
import { createRoom } from "../../services/RoomService";
import { initRoom } from "../../services/TexasService";
import "./CreateTexasRoom.css";
import "../../containers/ModalTheme.css";
import "../../containers/GroupPageCards.css";
import { getStableAnimalEmoji } from "../../utils/utils";

export default function CreateTexasRoom() {
  const history = useHistory();
  const [roomName, setRoomName] = useState("");
  const [maxPlayers, setMaxPlayers] = useState(6);
  const [isCreating, setIsCreating] = useState(false);

  const mascot = useMemo(() => getStableAnimalEmoji("texas-create"), []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!roomName.trim()) {
      alert("Please enter a room name");
      return;
    }

    setIsCreating(true);

    try {
      const room = await createRoom({
        name: roomName,
        gameType: "texas-holdem",
        maxPlayers: parseInt(maxPlayers),
      });

      // Initialize Texas-specific state (chips, blinds, seat fields)
      await initRoom(room.id);

      // Redirect to the room detail page
      history.push(`${process.env.PUBLIC_URL}/games/texas/${room.id}`);
    } catch (error) {
      console.error("Failed to create room:", error);
      alert("Failed to create room. Please try again.");
      setIsCreating(false);
    }
  };

  return (
    <div className="create-texas-room">
      <SceneBackground effectsProps={{ fluffCount: 20 }} />
      <GamesNavbar />
      
      <div className="create-room-content">
        <div className="container-xl">
          <div className="texas-create-card card shadow-sm as-card as-theme mx-auto">
            <div className="card-header as-card-header d-flex align-items-center justify-content-between">
              <div className="as-card-header-title">
                <span className="as-icon-badge" aria-hidden="true">♠️</span>
                <strong>Create Texas Poker Room</strong>
              </div>
              <div className="texas-create-mascot" aria-hidden="true">{mascot}</div>
            </div>

            <div className="card-body">
              <div className="texas-animal-row" aria-hidden="true">🐶🐱🐰🦊🐻🐼🐨🐯 🌿</div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Room Name</label>
              <input
                type="text"
                className="form-control"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
                placeholder="Enter room name..."
                maxLength={50}
                disabled={isCreating}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Maximum Players</label>
              <select
                className="form-select"
                value={maxPlayers}
                onChange={(e) => setMaxPlayers(e.target.value)}
                disabled={isCreating}
              >
                <option value={2}>2 Players</option>
                <option value={4}>4 Players</option>
                <option value={6}>6 Players</option>
                <option value={8}>8 Players</option>
                <option value={10}>10 Players</option>
                <option value={12}>12 Players</option>
              </select>
            </div>

            <button 
              type="submit" 
              className="btn as-btn-primary-gradient w-100"
              disabled={isCreating}
            >
              {isCreating ? "Creating..." : "Create Room"}
            </button>
          </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
